<template>
  <span class="custom-icon">
    <i class="icon-radio" :class="{ checked: value, disabled: disabled }"></i>
  </span>
</template>

<script>
export default {
  name: 'IconRadio',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
